import SeoHead from '@/components/feature/SeoHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import BrandIntro from './components/BrandIntro';
import Testimonials from './components/Testimonials';
import ContactInfo from './components/ContactInfo';
import { siteInfo } from '@/mocks/novels';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: window.location.origin,
  description: siteInfo.description,
  email: siteInfo.email,
  telephone: siteInfo.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: siteInfo.address,
    addressCountry: 'CN',
  },
  foundingDate: String(siteInfo.foundingYear),
};

export default function AboutPage() {
  return (
    <>
      <SeoHead
        title="关于我们 - 都市美艳后宫 | 品牌介绍与联系方式"
        description={`了解都市美艳后宫的品牌故事与发展历程。${siteInfo.description.substring(0, 80)}`}
        keywords="关于都市美艳后宫,品牌介绍,联系我们,都市爽文平台"
        canonicalUrl={`${window.location.origin}/about`}
        ogType="website"
        schema={aboutSchema}
      />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-background-50">
        <Navbar />
        <main className="flex-1 pt-16 md:pt-18">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
          <BrandIntro />
          <Testimonials />
          <ContactInfo />
        </main>
        <Footer />
      </div>
    </>
  );
}